import { ApiError } from 'src/error/customError/ApiError';
export class InternalServerError extends ApiError {}
